class NewFeaturedProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    const grid = this.querySelector(".product-grid");
    if (!grid) return;

    if ($(grid).hasClass("slick-initialized")) return;

    $(grid).slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4.1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3.1,
            arrows: true,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2.1,
            arrows: true,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
}

customElements.define("new-featured-product-slider", NewFeaturedProductSlider);
